import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed, ViewChildren, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn, Types } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { AktePopup } from "../Status/AktePopup";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { VersandUI } from "../../../Api/DcoApi/Versand/VersandUI";
import { VersandInfoControll } from "./VersandInfoControll";




@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent, VersandInfoControll
  ],
  selector: 'VersandStatus',
  templateUrl: './VersandStatus.html',
  standalone: true,
  styleUrl: './VersandStatus.css'
})
export class VersandStatus implements OnChanges, AfterViewInit {
  @ViewChild('Grid') childComponent!: DataGridView<VersandUI>;
  @Input() Status: number = 0;
  toastService: ToastService;

  private modalService = inject(NgbModal);
  selectedIDs: number[] = [];

  dataurl = computed(() => { return `/Backend/Api/V2/VersandAuftraege/${this.Status ?? 1}/List` })
  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)

  }
  ngAfterViewInit(): void {
    this.loadColumns();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["Status"]) {
      this.loadColumns();
    }
  }

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  loadColumns() {
    var columns = [{ field: 'versandAuftrag', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: VersandUI, field: any) => { return data.isRetoure ? 'Retoure' : 'Versand'; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<VersandUI>,
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'auftrag', header: 'Auftrag',
        cellClass:  (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.Number
      } as DataGridViewCollumn<VersandUI>),
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'versichertennummer', header: 'Versichertennummer',
        cellClass:  (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>),
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'vorname', header: 'Vorname',
        cellClass:  (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>),
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'nachname', header: 'Nachname',
        cellClass:  (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>),
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'seriennummer', header: 'Seriennummer',
        cellClass:  (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>),
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'trackingnummer', header: 'Trackingnummer',
        cellClass:  (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>),
      new DataGridViewCollumn<VersandUI>().setValues({
        field: 'statusChanged', header: 'Status Änderung',
        cellClass: (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<VersandUI>)
    ]

    if (this.Status == 2) {
      columns.push(new DataGridViewCollumn<VersandUI>().setValues({
        field: 'statusSendevervolgung', header: 'Status DHL',
        cellClass: (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>))
      columns.push(new DataGridViewCollumn<VersandUI>().setValues({
        field: 'letzterStatusText', header: 'Letzte DHL Meldung',
        cellClass: (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<VersandUI>))
      columns.push(new DataGridViewCollumn<VersandUI>().setValues({
        field: 'letzterSendeStatusChanged', header: 'Letzte Änderung Eingeganngen',
        cellClass: (data: VersandUI, field: any) => data.isRetoure ? 'Retoure' : 'Versand', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<VersandUI>))
    }



    columns.push(new DataGridViewCollumn<VersandUI>().setValues({ field: 'key', header: '', cellTemplate: this.buttonTemplate, isFixed: true, AllowSearch: false, AllowOrder: false, cellClass: (data: VersandUI, field: any) => { return ""; } } as DataGridViewCollumn<VersandUI>));
    if (this.childComponent) {
      this.childComponent.columns.reset(columns);
      this.childComponent.columns.notifyOnChanges();
    }
  }



  @ViewChild('buttonTemplate') buttonTemplate!: TemplateRef<any>;



  Client: RestClient = new RestClient();

  Caption() {
    var HeaderText = '';
    var Status = this.Status ?? -1;
    switch (Math.trunc(Status / 10)) {
      case 0:
        HeaderText = "";
        break;
      case 1:
        HeaderText = "Zu Versenden";
        break;
      case 2:
        HeaderText = "Versand";
        break;
      case 3:
        HeaderText = "Versand Abgeschlossen";
        break;


    }


    return HeaderText;
  }







}
